/* eslint-disable react/prop-types */
import { GetAccount200Response } from "../../../codegen-api";
import { CollateralsContainer } from "./style";
import Token from "./Token";
import { AllCollaterals } from "../../../constants/addresses";

interface ICollateralProps {
  isMobileScreen?: boolean;
  accountData?: GetAccount200Response;
  isLoading?: boolean;
  onDeposit?: (asset: AllCollaterals) => void;
  onWithdraw?: (asset: AllCollaterals) => void;
  onTransfer?: (asset: AllCollaterals) => void;
  onConvert?: (asset: AllCollaterals) => void;
}

function Collateral({
  isMobileScreen,
  accountData,
  isLoading,
  onDeposit,
  onWithdraw,
  onTransfer,
  onConvert,
}: ICollateralProps) {
  return (
    <CollateralsContainer>
      <Token
        isMobileScreen={isMobileScreen}
        accountData={accountData}
        isLoading={isLoading}
        onDeposit={onDeposit}
        onWithdraw={onWithdraw || undefined}
        onTransfer={onTransfer || undefined}
        onConvert={onConvert || undefined}
      />
    </CollateralsContainer>
  );
}

export default Collateral;
